module.exports = __webpack_public_path__ + "6456f2593cb3b31be810f91b6ccdedc1.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/misc/main-ideas-icon.png
// module id = 1677
// module chunks = 0